<div class="page-container payment-page-container">
  <div class="payment-page-content-wrap">
    <div class="inner-section payment-page-content">

      <div class="payments-form-wrap">
        <div class="tabs-item tab-menu">
          <div class="subscription-title">
            Управление подписками
            <svg (click)="openModalInteractive()" width="20" height="20" viewBox="0 0 20 20" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM9 13V15H11V13H9ZM11 11.3551C12.4457 10.9248 13.5 9.5855 13.5 8C13.5 6.067 11.933 4.5 10 4.5C8.302 4.5 6.88637 5.70919 6.56731 7.31346L8.5288 7.70577C8.6656 7.01823 9.2723 6.5 10 6.5C10.8284 6.5 11.5 7.17157 11.5 8C11.5 8.8284 10.8284 9.5 10 9.5C9.4477 9.5 9 9.9477 9 10.5V12H11V11.3551Z"
                fill="white"/>
            </svg>
          </div>

          <span class="sub-title">
            Для поиска вашей подписки необходимо заполнить форму ниже.
          </span>
        </div>

        <div [formGroup]="formCardInfo" class="payment-monthly">
          <div class="tabs-item tab-card">
            <div class="payment-block payment-card-block-outer">
              <div class="payment-card-block">
                <div class="payment-title ">
                  Номер карты
                </div>
                <div class="form-item card-item">
                  <input [maxlength]="7"
                         type="text"
                         tabindex="1"
                         formControlName="maskedPanBeginning"
                         moveToNext
                         inputmode="numeric"
                         [nextInput]="endNumber"
                         [prevInput]="undefined"
                         [maxLengthDirective]="7"
                         oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6).replace(/(\d{4})(\d{1,2})/, '$1 $2').trim()"
                         placeholder="ХХХХ ХХ" required #beginningNumber>
                  <span class="stars">** ****</span>


                  <input [maxlength]="4"
                         tabindex="2"
                         type="text"
                         formControlName="maskedPanEnd"
                         inputmode="numeric"
                         moveToNext
                         [nextInput]="undefined"
                         [prevInput]="beginningNumber"
                         [maxLengthDirective]="4"
                         oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                         placeholder="ХХХХ" required #endNumber>
                </div>

                <div class="payment-card-block-bottom">
                  <div class="payment-card-expires">
                    <div class="payment-title ">
                      действует до:
                    </div>
                    <div class="payment-card-expires-inner">
                      <div class="form-item">
                        <input formControlName="cardExpMonth"
                               inputmode="numeric"
                               tabindex="3"
                               pattern="[0-9]*"
                               type="text"
                               [maxlength]="2"
                               placeholder="MM"
                               oninput="this.value = this.value.replace(/[^0-9]/g, '');
                              if (this.value > 12) {
                              this.style.border = '2px solid red';
                              } else {
                               this.style.border = '';
                              }"
                               required
                               moveToNext
                               [nextInput]="year"
                               [prevInput]="undefined"
                               [maxLengthDirective]="2"
                               #month>
                      </div>

                      <svg width="5" height="24" viewBox="0 0 5 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.89038 0.424L1.93038 14.184H0.330375L3.29038 0.424H4.89038Z" fill="#393939"/>
                      </svg>

                      <div class="form-item">
                        <input formControlName="cardExpYear"
                               inputmode="numeric"
                               tabindex="4"
                               pattern="[0-9]*"
                               type="text"
                               [maxlength]="2"
                               placeholder="YY"
                               oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                               required
                               moveToNext
                               [nextInput]="undefined"
                               [prevInput]="month"
                               [maxLengthDirective]="2"
                               #year>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-card-contacts">
                <div class="block-payment">
                  <div class="contacts-item email-item">
                    <div class="payment-title">
                      сумма подписки
                    </div>
                    <div class="form-item">
                      <input type="text"
                             tabindex="5"
                             formControlName="sum"
                             inputmode="decimal"
                             pattern="[0-9,.]*"
                             onkeydown="return event.key === 'Backspace'
                            || event.key === 'Delete'
                            || (event.ctrlKey && event.key === 'v')
                            || (event.ctrlKey && event.key === 'c')
                            || (event.ctrlKey && event.key === 'с')
                            || (event.ctrlKey && event.key === 'м')
                            || (event.key === 'v' && event.metaKey)
                            || event.key === 'Tab'
                            || (!this.value.includes('.') && (event.key === '.' || event.key === ','))
                            || /[0-9]/.test(event.key)"
                             oninput="
                             this.value = this.value.replace(',', '.').replace(/[^0-9.]/g, '');
                            if ((this.value.match(/\./g) || []).length > 1) {
                           this.value = this.value.slice(0, -1);
                           }
                          if (this.value === '0' || this.value.endsWith('.')) {
                         this.style.border = '2px solid red';
                           } else if (this.value >0) {
                               this.style.border = '2px #ffffff solid';
                              } else {
                               this.style.border = '2px transparent solid';
                              }"
                             [maxlength]="13"
                             onkeypress="if (this.value.length === 0 && event.key === '0') {
                    event.preventDefault();
                  }"
                             placeholder="Введите сумму"
                             required>

                    </div>
                  </div>
                  <div class="contacts-item email-item">
                    <div class="payment-title ">
                      Дата первого платежа
                    </div>
                    <div class="form-item">
                      <input type="text"
                             inputmode="numeric"
                             tabindex="6"
                             pattern="[0-9]*"
                             formControlName="firstTransactionDate"
                             validator-date
                             [maxlength]="10"
                             [minLength]="10"
                             (dateChange)="formCardInfo.controls.firstTransactionDate.setValue($event)"
                             [date-value]="formCardInfo.value.firstTransactionDate"
                             [ngClass]="{'input-filled': formCardInfo.value.firstTransactionDate}"
                             placeholder="__.__.____"
                             required>
                    </div>
                  </div>
                </div>

                <div class="contacts-item number-item">
                  <div class="payment-title ">
                    № транзакции при первом платеже
                  </div>
                  <div class="form-item">
                    <input type="text"
                           tabindex="7"
                           inputmode="numeric"
                           [ngClass]="{'input-filled': formCardInfo.value.firstTransactionNumber}"
                           formControlName="firstTransactionNumber"
                           placeholder="Введите номер"
                           [maxlength]="16"
                           oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                           onkeydown="return event.key === 'Backspace'
                           || (event.ctrlKey && event.key === 'v') ||
                           (event.ctrlKey && event.key === 'c')
                           || (event.ctrlKey && event.key === 'с') ||
                           (event.ctrlKey && event.key === 'м')
                           || (event.key === 'v' && event.metaKey)
                           || event.key === 'Delete'
                           || /[0-9]/.test(event.key)"
                           required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="captcha-container"></div>
        <button (click)="submitForm()"
                [ngClass]="{'active-button': formCardInfo.valid}"
                [disabled]="!formCardInfo.valid"
                class="button submit-button generate-qr-button">
          Найти
        </button>

        <div class="payment-footer">
          <a href="https://pobeda.onf.ru/" class="button">
            вернуться назад
          </a>
          <img class="payment-footer-img" src="assets/images/ul-kit/footer-logos.png" alt="">
        </div>
      </div>
    </div>
  </div>
</div>
